import { type CSSProperties, type ReactNode } from 'react';
import styles from './PageContainer.module.css';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  background?: 'dark' | 'light';
  paddingX?: 'none' | 'sm' | 'md';
}

export function PageContainer({
  children,
  className = '',
  style,
  background = 'dark',
  paddingX = 'md',
}: PageContainerProps): JSX.Element {
  return (
    <section
      className={`${styles.page} ${styles[`bg_${background}`]} ${styles[`px_${paddingX}`]} ${className}`}
      style={style}
    >
      {children}
    </section>
  );
}
